import api from '../services/api';
import { getUsuarioSessao } from './sessao';
import { dadosOrg, fetchLogoBase64 } from './impressaoVenda';

// Cabeçalho comum dos relatórios impressos: logo e dados da empresa do login
// desta guia. Se a empresa não carregar, devolve null e o relatório sai sem
// esse bloco, em vez de não imprimir.
export async function carregarEmpresaRelatorio(orgId = getUsuarioSessao()?.organizacao_id) {
  if (!orgId) return null;
  try {
    const { data } = await api.get(`/organizacoes/${orgId}`);
    return { ...dadosOrg(data), logo: await fetchLogoBase64(data.logo_url || '') };
  } catch {
    return null;
  }
}

export const escHtml = s => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// Estilos no próprio elemento: entra em qualquer relatório sem depender do CSS dele.
export function cabecalhoEmpresaHtml(empresa) {
  if (!empresa) return '';
  const local = [empresa.endereco, empresa.cidadeUF, empresa.fone].filter(Boolean).join(' — ');
  return `<div class="emp" style="display:flex;align-items:center;gap:12px;border-bottom:1px solid #999;padding-bottom:8px;margin-bottom:10px;white-space:normal;font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#333;">
    ${empresa.logo ? `<img src="${empresa.logo}" alt="" style="max-height:55px;max-width:130px;object-fit:contain;">` : ''}
    <div>
      <strong style="font-size:13px;">${escHtml(empresa.nome)}</strong>
      ${empresa.cnpj ? `<div>CNPJ: ${escHtml(empresa.cnpj)}</div>` : ''}
      ${local ? `<div>${escHtml(local)}</div>` : ''}
    </div>
  </div>`;
}
